import {
    AVIS_INICIALITZAR,
    AVIS_VISUALITZACIO_SELECCIONAR_AVIS,
    AVIS_VISUALITZACIO_OBTENIR
} from '../../../../actions/actionTypes';

const ESTAT_INICIAL = null;

const idAvisSeleccionat = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR: {
            if (state === ESTAT_INICIAL) {
                return state;
            }

            const avisos = action.avisos;
            return avisos.some(avis => avis.id === state) ? state : ESTAT_INICIAL;
        }

        case AVIS_VISUALITZACIO_SELECCIONAR_AVIS:
            return action.idAvisSeleccionat;

        default:
            return state;
    }
};

export default idAvisSeleccionat;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/avisos/idAvisSeleccionat.js